import React from 'react';

import { ReviewCards } from '@/components/ReviewCards';
import { UiTypography } from '@/components/ui/Typography';
import { OnboardingTitle } from '@/pages/Onboarding/components/Title';

import './Reviews.scss';

export const OnboardingPaywallSectionReviews: React.FC = () => {
  return (
    <section className="reviews">
      <OnboardingTitle className="title">
        Our{' '}
        <UiTypography variant="inherit" color="gradient" component="span">
          users
        </UiTypography>{' '}
        say
      </OnboardingTitle>

      <ReviewCards />
    </section>
  );
};
